/*
登录接口
*/ 
import { axios } from '@/utils/http'

// 发送短信
export const sendCode = (params) => axios({
  method: 'POST',
  data: {
    ...params
  },
  noToast: true
}, '/user/sendLoginSms')

// 找回密码发送短信
export const sendResetPwdSms = (params) => axios({
  method: 'POST',
  data: {
    ...params
  },
  noToast: true
}, '/user/sendResetPwdSms')

// 找回密码 验证 验证码
export const validMsgCodeResetPwd = (params) => axios({
  method: 'POST',
  data: {
    ...params
  },
  noToast: true
}, '/user/validMsgCodeResetPwd')

// 找回密码 重置密码
export const resetPwd = (params) => axios({
  method: 'POST',
  data: {
    ...params
  },
  noToast: true
}, '/user/resetPwd')


//用户登录
export const userLogin = (params) => axios({
  method: 'GET',
  data: {
    ...params
  },
  noToast: true
}, '/user/fastlogin')

//用户密码登录
export const pwdLogin = (params) => axios({
  method: 'post',
  data: {
    ...params
  },
  noToast: true
}, '/user/pwdLogin')

//用户密码注册
export const pwdregister = (params) => axios({
  method: 'post',
  data: {
    ...params
  },
  noToast: true
}, '/user/register')

//用户修改密码
export const modifyPwd = (params) => axios({
  method: 'post',
  data: {
    ...params
  },
  noToast: true
}, '/user/modifyPwd')


// 脸书登陆
export const loginFacebook = (params) => axios({
  method: 'POST',
  data: {
    ...params
  }
}, '/user/loginFacebook')

// 脸书注册
export const registerFacebook = (params) => axios({
  method: 'POST',
  data: {
    ...params
  }
}, '/user/registerFacebook')

// 脸书绑定
export const bindingFacebook = (params) => axios({
  method: 'POST',
  data: {
    ...params
  }
}, '/user/bindingFacebook')

// 校验脸书ID令牌
export const checkFaceBookIDToken = (params) => axios({
  method: 'POST',
  data: {
    ...params
  }
}, '/user/checkFaceBookIDToken')

// 谷歌登陆
export const loginGoogle = (params) => axios({
  method: 'POST',
  data: {
    ...params
  }
}, '/user/loginGoogle')

// 谷歌注册
export const registerGoogle = (params) => axios({
  method: 'POST',
  data: {
    ...params
  }
}, '/user/registerGoogle')

// 谷歌绑定
export const bindingGoogle = (params) => axios({
  method: 'POST',
  data: {
    ...params
  }
}, '/user/bindingGoogle')

// 校验谷歌ID令牌
export const checkGoogleIDToken = (params) => axios({
  method: 'POST',
  data: {
    ...params
  }
}, '/user/checkGoogleIDToken')


// 根据手机号获取用户是否注册会员以及卡政策配置信息
export const getInfoByPhoneNum = (params) => axios({
  method: 'POST',
  data: {
    ...params
  }
}, '/user/getInfoByPhoneNum')


// WEBPACK FOOTER //
// ./src/api/login/login.js